import React, { useRef } from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { Download } from 'lucide-react';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const SCurveChart = ({ data, title }) => {
  const chartRef = useRef(null);

  if (!data) {
    return (
      <div className="flex items-center justify-center h-full text-gray-400">
        <p>No S-Curve data available.</p>
      </div>
    );
  }

  const handleDownloadChart = () => {
    if (chartRef.current) {
      const link = document.createElement('a');
      link.download = `${title.replace(/\s/g, '_')}_S-Curve_Chart.png`;
      link.href = chartRef.current.toBase64Image();
      link.click();
    }
  };

  const chartData = {
    labels: data.actual.map(d => d.date),
    datasets: [
      {
        label: 'Actual Progress',
        data: data.actual.map(d => d.cumulative_progress_percent),
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
        tension: 0.4,
        pointRadius: 4,
        pointBackgroundColor: 'rgb(255, 99, 132)',
        pointBorderColor: '#fff',
        pointHoverRadius: 6,
        fill: false,
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          font: {
            size: 12,
            weight: 'bold'
          },
          color: '#333'
        }
      },
      title: {
        display: true,
        text: title,
        font: {
          size: 18,
          weight: 'bold'
        },
        color: '#333'
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.parsed.y !== null) {
              label += context.parsed.y + '%';
            }
            return label;
          }
        }
      }
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Date',
          font: {
            size: 14,
            weight: 'bold'
          },
          color: '#555'
        },
        grid: {
          display: false
        }
      },
      y: {
        title: {
          display: true,
          text: 'Cumulative Progress (%)',
          font: {
            size: 14,
            weight: 'bold'
          },
          color: '#555'
        },
        min: 0,
        max: 100,
        ticks: {
          stepSize: 10,
          callback: function(value) {
            return value + '%';
          }
        },
        grid: {
          color: 'rgba(200, 200, 200, 0.2)'
        }
      }
    }
  };

  return (
    <div className="relative w-full h-96">
      <Line ref={chartRef} data={chartData} options={options} />
      <button
        onClick={handleDownloadChart}
        className="absolute top-4 right-4 bg-blue-500 text-white p-2 rounded-full shadow-lg hover:bg-blue-600 transition-colors duration-200 z-10"
        title="Download Chart"
      >
        <Download size={20} />
      </button>
    </div>
  );
};

export default SCurveChart;